import { render, staticRenderFns } from "./myCommentDetail.vue?vue&type=template&id=654bb4d2&scoped=true"
import script from "./myCommentDetail.vue?vue&type=script&lang=js"
export * from "./myCommentDetail.vue?vue&type=script&lang=js"
import style0 from "./myCommentDetail.vue?vue&type=style&index=0&id=654bb4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654bb4d2",
  null
  
)

export default component.exports